export const SpinLoader = <div><div className="ld ld-spinner  ld-spin"></div></div>
export const SpinLoaderStyle = <div style={{
  textAlign: 'center', 
  height: '7em',
  position: 'relative',
  top: '2.5em'
}}><div className="ld ld-spinner  ld-spin"></div></div>